<template>
  <!-- <div>
    <div><img class="cdTitleImg" src="/img/changDu/s_bm.jpg" alt=""></div>
    <div class="dragonStatic">
      <div class="staticContent cdStaticContent">
        <p class="bold blackSubTitle indent">1、报名时间</p>
        <p class="indent mgBtm">本次大赛所有参赛作品与报名材料投稿期限为2020年10月10日至11月10日。</p>

        <p class="bold blackSubTitle indent">2、报名方式</p>
        <p class="indent">1）由主办单位发文，北京市、天津市、河北省各相关行业协会、学会（工业设计协会、设计学学会、文创协会等）、园区、企业和中小学、高校、机构协作号召征集，将作品图文件和报名表统一交由学校、协会、收集并筛选后，报送推荐到大赛组委会，由组委会统一提交至大赛指定官网。</p>
        <p class="indent">2）除上述方式外，也可由上述各单位直接登录组委会指定大赛官网，按照要求填写报名材料、提交参赛作品，如有参赛实物作品，可寄送至大赛组委会办公室（地址：天津市东丽区津汉公路天安智慧港A4绿色设计研究院，邮编：300000）。</p>
        <p class="indent mgBtm">搜索官方微信公众号“光华设计基金会”了解更多大赛详情。</p>

        <p class="bold blackSubTitle indent">3、报名须知</p>
        <p class="indent">1）参赛者或单位要保证参赛作品不侵犯他人知识产权专利作品需要提交专利证书复印件。如作品发生知识产权或版权纠纷等，组委会将取消其参赛资格，并由作者承担相应后果。所有因参展作品引发的版权或知识产权纠纷概与组委会无关。</p>
        <p class="indent">2）凡报名参赛的作者视为无条件同意大赛作品参加主办方举办的一切非盈利性展示活动及相关宣传推介活动。</p>
        <p class="indent">3）设计费、模型费、样品及产品制作费、邮寄费等费用均由参赛者自行承担。凡通过邮寄方式报送实物作品的，在邮寄过程中如发生丢失、破损等问题，组委会概不负责。</p>
        <p class="indent">4）凡报送作品参赛作者，视为已确认并遵守本征稿通知的各项规定，最终解释权归大赛组委会所有。</p>
      </div>  
    </div>
  </div> -->
  <div>
    <div v-if="show=='group'"><img class="cdTitleImg" src="/img/changDu/s_bm.jpg" alt=""></div>
    <div class="signUp container">
      <div v-if="show=='group'" class="formBox">
        <p class="bold mgBtm">选择参赛组别（选择后不能修改，请您慎重选择）：</p>
        <p class="mgBtm">专业组：职业设计师、设计企业。</p>
        <p class="mgBtm">高校组：教师、学生（个人或团体）。</p>
        <p class="mgBtm">社会组：设计爱好者。</p>
        <Row :gutter="30">
          <Col :md="8" :xs="24" v-for="(g, i) in groupList" :key="i">
            <div 
              class="typeItem" 
              :class="{'typeItemActive': groupId==g.id}" 
              @click="selectGroup(g)"
            >{{g.name}}</div>
          </Col>
        </Row>
        <div class="center">
          <Button class="signUpBtn" shape="circle" :loading="submitting" @click="confirmGroup">确定</Button>
        </div>
      </div>
      
      <div v-if="show=='form'" class="formBox">
        <h4 class="center formTitle">
          <span>昌都文旅设计大赛报名表</span>
          <span v-if="info.id" class="textBtn" @click="showChange('works')">管理参赛作品</span>
        </h4>
        <Form ref="form" :model="info" :rules="rules" class="formStyle">
          <div class="formWrap">
            <div class="imgWrap">
              <FormItem prop="photo">
                <img v-if="info.photo" :src="getImageUrl(info.photo, 'competition_photo')" class="photoImg" alt="">
              </FormItem>  
              <div class="buttonText">
                <Upload
                  :action="imgApi"
                  :headers="{Authorization: token}"
                  name="picture"
                  :data="{applyType: 'COMPETITION'}"
                  :show-upload-list="false"
                  :on-success="handleSuccess"
                  :before-upload="handleBeforeUpload" 
                  :on-format-error="handleFormatError"
                  :on-error="handleError"
                  :on-exceeded-size="handleSize"
                  :max-size="5120"
                  accept="image/jpg, image/png, image/jpeg">
                <Icon v-if="!uploading" :type="info.photo?'ios-create-outline':'ios-add'" size="30" />
                <Icon v-if="uploading" type="ios-loading" size="40" class="icon-load" />
                <p>{{info.photo?'修改':'上传'}}本人照片</p>
                <p>（需正面免冠照）</p>
                </Upload>
              </div>
            </div>
            <Row :gutter="30">
              <Col :md="12" :xs="24">
                <FormItem prop="university" label="所在院校/单位">
                  <Input type="text" v-model="info.university"></Input>
                </FormItem>
              </Col>
              <Col :md="12" :xs="24">
                <FormItem prop="major" label="专业">
                  <Input type="text" v-model="info.major"></Input>
                </FormItem>
              </Col>
              <Col :md="12" :xs="24">
                <FormItem prop="address" label="通讯地址">
                  <Input type="text" v-model="info.address"></Input>
                </FormItem>
              </Col>
              <Col :md="12" :xs="24">
                <FormItem prop="postcode" label="邮编">
                  <Input type="text" v-model="info.postcode"></Input>
                </FormItem>
              </Col>
              <Col :md="12" :xs="24">
                <FormItem prop="weChatId" label="微信号">
                  <Input type="text" v-model="info.weChatId"></Input>
                </FormItem>
              </Col>
              <Col :md="12" :xs="24">
                <FormItem prop="email" label="电子邮箱">
                  <Input type="text" v-model="info.email"></Input>
                </FormItem>
              </Col>
              <Col :md="12" :xs="24">
                <FormItem prop="sex" label="性别">
                  <Select v-model="info.sex" placeholder="">
                    <Option value="男">男</Option>
                    <Option value="女">女</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col :md="12" :xs="24">
                <FormItem prop="teacher" label="指导老师">
                  <Input type="text" v-model="info.teacher"></Input>
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem prop="description" label="个人简介（1000字以内）">
                  <Input type="textarea" :autosize="{minRows: 4}" v-model="info.description"></Input>
                </FormItem>
              </Col>
            </Row>
          </div>
        </Form>
        <div class="center">
          <Button class="signUpBtn" shape="circle" :loading="submitting" @click="submitForm">提交报名表</Button>
        </div>
      </div>

      <div v-if="show=='works'" class="workBox">
        <Row>
          <Col :lg="{span:16, push: 8}" :xs="24" align="right" class="btnLeft">
            <Button class="signUpBtn" shape="circle" @click="showChange('form')">管理报名信息</Button>
            <Button class="signUpBtn mgLeft" shape="circle" to="/personal_info" target="_blank">完善个人档案</Button>
          </Col>
          <Col :lg="{span: 8, pull: 16}" :xs="24">
            <Button class="signUpBtn" shape="circle" @click="showType">提交参赛作品</Button>
          </Col>
        </Row>
        <div class="worksWrap">
          <h4>已提交作品（{{total}}）</h4>
          <div v-if="total==0" class="empty">
            <Icon class="infoIcon" type="ios-alert-outline"/>
            <span>还未提交作品</span>
          </div>
          <Row :gutter="30">
            <Col :lg="{span:8}" :xs="{span:12}" v-for="(l, i) in list" :key="l.id">
              <div class="workImgWrap">
                <img v-if="l.cover" :src="getImageUrl(l.cover, 'competition_works')" class="workImg" alt="">
              </div>
              <div class="center worksInfoWrap">
                <h4 class="ellipsis">{{l.name}}</h4>
                <p class="ellipsis">{{l.awardTypeName}}</p>
                <p>
                  <span class="edit" @click="editWork(i)">编辑</span>
                  <span class="delete" @click="deleteWork(l)"><Icon type="ios-trash-outline" size="16" />删除</span>
                </p>  
              </div>
            </Col>
          </Row>
        </div>

        <Modal v-model="workTypeShow"
          title="提交参赛作品"
          :mask-closable="false"
          :footer-hide="true"
          width="520">
          <div>
            <p class="smallTitle">选择作品参赛类型（单选）</p>
            <Row :gutter="30">
              <Col :md="12" :xs="24" v-for="(t, i) in awardTypeList" :key="i">
                <div 
                  class="typeItem" 
                  :class="{'typeItemActive': workInfo.awardTypeName==t.name}" 
                  @click="selectType(t)"
                >{{t.name}}</div>
              </Col>
            </Row>
            <p class="center"><Button class="signUpBtn" shape="circle" @click="nextStep">下一步</Button></p>
          </div>
        </Modal>
        
        <Modal v-model="workInfoShow"
          title="编辑参赛作品"
          :mask-closable="false"
          :footer-hide="true"
          width="520">
          <WorkInfo v-if="workInfoShow" :info="workInfo" @EntrySucc="getWorkList" @PrevStep="prevStep" type="dragonStar" />
        </Modal>
      </div>
    </div>
  </div>
</template>

<script>
import WorkInfo from "@/components/form/WorkInfo.vue";

import competitionService from "@/api/competition";
import personalService from "@/api/personal";
import { baseUrl } from "@/config/env";
export default {
  components: {
    WorkInfo
  },
  data() {
    return {
      show: null,
      imgApi: `${baseUrl}picture/upload`,
      token: this.$store.getters.token,
      userInfo: {},
      education: {},
      uploading: false,

      info: { competitionId: '704428603570320', photo: "" },
      rules: {
        photo: [
          {
            required: true,
            message: "请上传本人正面免冠照片",
            trigger: "change"
          }
        ],
        // university: [{ required: true, message: "请输入所在院校/单位" }],
        // major: [
        //   { required: true, message: "请输入专业", trigger: "blur,change" }
        // ],
        address: [
          { required: true, message: "请输入通讯地址", trigger: "blur,change" }
        ],
        postcode: [
          { required: true, message: "请输入邮编", trigger: "blur,change" }
        ],
        weChatId: [
          { required: true, message: "请输入微信号", trigger: "blur,change" }
        ],
        email: [
          {
            required: true,
            message: "请输入正确的电子邮箱",
            pattern: /[\w]+(\.[\w]+)*@[\w]+(\.[\w])+/,
            trigger: "blur,change"
          }
        ],
        sex: [
          { required: true, message: "请选择性别", trigger: "blur,change" }
        ],
        // teacher: [
        //   { required: true, message: "请输入指导老师", trigger: "blur,change" }
        // ],
        description: [
          {
            required: true,
            message: "请输入个人简介（1000字以内）",
            trigger: "blur,change",
            max: 1000
          }
        ]
      },
      submitting: false,

      total: 0,
      list: [],
      page: 0,
      awardTypeList: [],

      workTypeShow: false,
      workInfoShow: false,

      workInfo: {},

      groupList: [
        { id: 1, name: "专业组" },
        { id: 2, name: "高校组" },
        { id: 3, name: "社会组" }
      ],
      groupId: null,

      competitionId : '704428603570320'

    };
  },
  mounted() {
    this.show = "group";
    // 先判断是否选择过参赛组别
    // 再判断是否提交过报名表
    // 如果提交过报名表显示参赛作品页
    // 如果url参数中有isShow=1，并且没有选择过参赛组别则显示报名须知
    if(this.gIsLogin()){
      this.userInfo = this.$store.getters.userInfo || {}
      this.getAwardType()
      this.getWorkList()
      setTimeout(this.getInfo, 500)
    }else{
      this.$Modal.confirm({
        title: '提示',
        content: '登录后才能报名',
        okText: '去登录',
        onOk: () => {
          this.$router.push('/login?fromUrl=/chang_du/sign_up')
        },
        onCancel: () => {
          this.$router.push('/chang_du/index')
        }
      });
    }
  },
  methods: {
    // 选择参赛组别
    selectGroup(val) {
      this.groupId = val.id;
      this.info.groupId = this.groupId
    },
    // 提交参赛组别
    confirmGroup() {
      if (this.groupId) {
        // 将groupId提交给后台
        console.log(this.info);

        this.submitting = true;
        competitionService
        .saveCompetitionRegistration(this.info)
        .then(res => {
          if (res.errorNo == 0) {
            // 提交成功之后执行
            // 显示报名信息
            this.show = "form";
          } else {
            this.$Message.error(res.errorMessage);
          }
          this.submitting = false;
        })
        .catch(err => {
          // this.$Message.error(err.message)
          console.log(err.message);
          this.$Message.error("连接服务器失败，请稍后再试");
          this.submitting = false;
        });

      } else {
        this.$Message.error("请选择参赛组别");
      }
    },
    // 提交报名表
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitting = true;
          competitionService
            .saveCompetitionRegistration(this.info)
            .then(res => {
              if (res.errorNo == 0) {
                // 提交成功之后执行
                // 显示作品信息
                this.show = "works";
              } else {
                this.$Message.error(res.errorMessage);
              }
              this.submitting = false;
            })
            .catch(err => {
              // this.$Message.error(err.message)
              console.log(err.message);
              this.$Message.error("连接服务器失败，请稍后再试");
              this.submitting = false;
            });
        } else {
          this.$Message.error("信息未正确填写完整");
        }
      });
    },
    // 获取报名信息
    getInfo() {
      let param = { "competitionId.eq": this.competitionId };
      competitionService
        .getCompetitionRegistration(param)
        .then(res => {
          if (res.errorNo == 0) {
            if (res.data) {
              if (res.data.length > 0) {
                this.info = res.data[0];

                if (this.info.photo) {
                  this.show = "works";
                } else {
                  if(this.info.groupId){
                    this.show = "form";
                  }else{
                    let isShow = this.$route.query.isShow;
                    if (isShow == 1) {
                      this.$parent.toSignUp();
                    }
                    this.show = "group";
                  }
                }
              } else {
                let isShow = this.$route.query.isShow;
                if (isShow == 1) {
                  this.$parent.toSignUp();
                }
                this.show = "group";

                if (this.userInfo.address) {
                  this.info.address = this.userInfo.address;
                }
                if (this.userInfo.wechatSubscription) {
                  this.info.weChatId = this.userInfo.wechatSubscription;
                }
                if (this.userInfo.email) {
                  this.info.email = this.userInfo.email;
                }
                if (this.userInfo.sex) {
                  this.info.sex = this.userInfo.sex;
                }
                if (this.userInfo.description) {
                  this.info.description = this.userInfo.description;
                }

                // this.$forceUpdate()
              }
            }
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(err => {
          // this.$Message.error(err.message)
          console.log(err.message);
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    },
    // 获取奖项类型
    getAwardType() {
      let param = { "competitionId.eq": this.competitionId };
      competitionService
        .getAwardTypes(param)
        .then(res => {
          if (res.errorNo == 0) {
            if (res.data) {
              this.awardTypeList = res.data;
            }
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(() => {
          // this.$Message.error(err.message)
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    },
    // 获取教育背景
    getEducationList() {
      personalService
        .getEducationByAccountId({ "accountId.eq": this.userInfo.accountId })
        .then(res => {
          if (res.errorNo == 0) {
            if (res.data) {
              if (res.data.length > 0) {
                this.education = res.data[0];
              }
            }
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(err => {
          // this.$Message.error(err.message)
          console.log(err.message);
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    },
    // 切换显示报名表和参赛作品
    showChange(val) {
      this.show = val;
    },
    // 提交参赛作品
    showType() {
      this.workInfo = { awardTypeId: "", awardTypeName: "", pictures: [] };
      this.workTypeShow = true;
    },
    // 编辑参赛作品
    editWork(i) {
      this.workInfo = Object.assign({}, this.list[i]);
      this.workTypeShow = true;
    },
    // 删除参赛作品
    deleteWork(work) {
      this.$Modal.confirm({
        title: "删除参赛作品",
        content: "确定要删除参赛作品“" + work.name + "”吗？",
        onOk: () => {
          competitionService
            .deleteOneProject(work.id)
            .then(res => {
              if (res.errorNo == 0) {
                this.$Message.info("删除参赛作品成功");
                this.getWorkList();
              } else {
                this.$Message.error(res.errorMessage);
              }
            })
            .catch(err => {
              // this.$Message.error(err.message)
              console.log(err.message);
              this.$Message.error("连接服务器失败，请稍后再试");
            });
        },
        onCancel: () => {
          // this.$Message.info('Clicked cancel');
        }
      });
    },
    // 提交作品成功后获取作品列表
    getWorkList() {
      this.workInfoShow = false;
      let param = { "userId.eq": this.userInfo.id, 'competitionId.eq': this.competitionId };
      competitionService
        .getProjects(param)
        .then(res => {
          if (res.errorNo == 0) {
            if (res.data) {
              this.total = res.data.length;
              this.list = res.data;
            }
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(err => {
          // this.$Message.error(err.message)
          console.log(err.message);
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    },
    // 上传照片成功
    handleSuccess(res) {
      if (res.errorNo) {
        this.$Message.error(res.errorMessage);
      } else {
        let data = res.data;
        this.info.photo = data.path;
        this.uploading = false;
        // this.$forceUpdate()
        this.$refs.form.validateField("photo");
      }
    },
    handleBeforeUpload(file) {
      let check = true;
      if (file.size == 0) {
        check = false;
      }
      this.uploading = true;
      return check;
    },
    // 文件超出最大值5M
    handleSize() {
      this.$Message.info("文件超过最大值5M，请重新选择！");
      this.uploading = false;
    },
    // 文件格式错误提示
    handleFormatError(file) {
      this.$Message.error(`文件${file.name}格式错误`);
      this.uploading = false;
    },
    // 错误提示
    handleError(error) {
      this.$Message.error("服务器错误" + error);
      this.uploading = false;
    },
    // 选择参赛作品类型
    selectType(type) {
      this.workInfo.awardTypeName = type.name;
      this.workInfo.awardTypeId = type.id;
      this.workInfo.competitionId = this.competitionId
    },
    // 选择参赛类型后的下一步
    nextStep() {
      if (this.workInfo.awardTypeId) {
        this.workTypeShow = false;
        this.workInfoShow = true;
      } else {
        this.$Message.error("请选择作品参赛类型");
      }
    },
    // 上一步
    prevStep() {
      this.workInfoShow = false;
      this.workTypeShow = true;
    }
  }
};
</script>


<style lang="scss" scoped>
// .blackSubTitle {
//   font-size: 20px;
//   padding-bottom: 10px;
// }
.mgBtm {
  margin-bottom: 15px;
}
.signUp {
  padding: 0 110px;

  .formBox {
    box-shadow: 0 2px 10px 3px rgba($color: #000000, $alpha: 0.1);
    padding: 20px 30px 30px;
    margin: 10px 0 50px;

    .formTitle {
      position: relative;
      margin-bottom: 20px;
      font-size: 16px;

      .textBtn {
        position: absolute;
        right: 0;
        top: 2px;
        font-size: 12px;
        font-weight: 400;
        cursor: pointer;
        color: #47b135;
      }
    }
    .formWrap {
      position: relative;
      padding-left: 150px;

      .imgWrap {
        position: absolute;
        width: 120px;
        left: 0;
        top: 15px;
        padding-bottom: 126px;
        background: #e6e6e6;

        .buttonText {
          // display: none;
          position: absolute;
          left: 0;
          right: 0;
          // top: 32px;
          top: 0;
          bottom: 0;
          padding: 30px 0;
          font-size: 12px;
          text-align: center;
          // color: #a2a2a2;
          color: #fff;
          background: rgba($color: #000000, $alpha: 0.35);
          cursor: pointer;
        }

        .icon-load {
          animation: m-loading 1s linear infinite;
          -webkit-animation: m-loading 1s linear infinite;
        }
        @keyframes m-loading {
          from {
            transform: rotate(0deg);
          }
          50% {
            transform: rotate(180deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        .photoImg {
          width: 100%;
          position: absolute;
        }
      }
      .imgWrap:hover .buttonText {
        display: inline-block;
      }
    }
  }
  .workBox {
    padding: 20px 30px 30px;

    .mgLeft {
      margin-left: 15px;
    }
    .worksWrap {
      padding: 15px 0;

      .empty {
        text-align: center;
        padding: 50px 0;

        .infoIcon {
          font-size: 18px;
          vertical-align: middle;
          margin-right: 5px;
        }
      }

      .workImgWrap {
        position: relative;
        padding-bottom: 65%;
        background: #a2a2a2;
        margin-top: 10px;
        margin-bottom: 10px;
        border-radius: 5px;
        overflow: hidden;
        box-shadow: 0 2px 5px 3px rgba($color: #47b135, $alpha: 0.1);
        .workImg {
          position: absolute;
          width: 100%;
        }
      }
      .worksInfoWrap {
        padding: 0 30px 10px;

        .edit {
          display: inline-block;
          cursor: pointer;
          padding-left: 20px;
          background: url(/img/editGreen.png) no-repeat left center;
          background-size: 12px;
          color: #47b135;
          font-size: 12px;
        }

        .delete {
          display: inline-block;
          cursor: pointer;
          margin-left: 10px;
          background-size: 12px;
          color: #47b135;
          font-size: 12px;
        }
      }
    }
  }
}

.signUpBtn {
  margin-top: 20px;
  padding: 0 50px;
  background: linear-gradient(to right, #d42a1b, #f31c08);
  border-color: #d42a1b;
  box-shadow: 0 2px 5px 2px rgba(202, 55, 55, 0.3);
}
.smallTitle {
  font-size: 12px;
  padding-bottom: 10px;
}
.typeItem {
  background: #e6e6e6;
  color: #221715;
  border-radius: 100px;
  margin-bottom: 18px;
  padding: 6px 0;
  text-align: center;
  cursor: pointer;
}
.typeItemActive {
  color: #ffffff;
  // background: linear-gradient(to right, #0ba83b, #75bb2a);
  // border-color: #75bb2a;
  // box-shadow: 0 2px 5px 2px rgba($color: #47b135, $alpha: .3);
  background: linear-gradient(to right, #d42a1b, #f31c08);
  border-color: #d42a1b;
  box-shadow: 0 2px 5px 2px rgba(202, 55, 55, 0.3);
}

@media (max-width: 992px) {
  .signUp {
    padding-left: 0;
    padding-right: 0;

    .formBox,
    .workBox {
      padding-left: 15px;
      padding-right: 15px;
    }

    .formBox .formWrap {
      padding-left: 0;

      .imgWrap {
        position: relative;
        top: 0;
        margin: 0 auto 20px;
      }
    }
  }
  .signUpBtn {
    margin-top: 20px;
    padding: 0 35px;
  }
  .btnLeft {
    text-align: left;
  }
}
</style>
